import ColorPicker from './../../../../components/ColorPicker';
import HeadTittle from '../../../../components/HeadTittle';
import routes from '../../../../Routes/routes';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import {
    CrossIconsOptions,
    EditIcon,
    EmailSubsectionChip,
    EyeIcon,
    IconAreaTable,
    IconClip,
    IconColorPalette,
    IconCubeDefault,
    IconMarkerTable,
    IconMarketLocation,
    IconWeb,
    MapTabIcon,
    QRDefault,
    SettingsIcon,
} from '../../../../components/buttons/IconButtons';
import CustomListContainer from '../../../../components/CustomListContainer';
import { FILE_TYPE } from '../../../../Helpers/fileType';
import { permissionObj } from '../../../../Helpers/permission';
import VCardSettingsApp from './Functionality/VCardSettingsApp';
import { ACTION_MODEL } from '../../../../Helpers/ActionModel';
import CustomPhotoPicker from '../../../../components/PhotoPicker/CustomPhotoPicker';
import CustomCard from '../../../../components/CustomCard';
import { PhoneOutlined } from '@mui/icons-material';
import InformationItem from './SubComponents/InformationItem';
import DraggableCard from '../../Traffic/Manage/SubComponents/DraggableCard';
import { QrDefaultStyle } from '../../../../components/Styles';
import DivContainerBody from '../../../../components/DivContainerBody';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 */
const VCardSettings = () => {
    const {
        t,
        permission,
        DEV,
        navigate,
        contractorId,
        supplierId,
        availableHeaders,
        assignedItems,
        colorVCard,
        setColorVCard,
        handleDragStart,
        handleDropAssigned,
        handleDropAvailable,
        handleDragOver,
        handleUpdateVCardSettings,
        photoPicker,
        setPhotoPicker,
        handleRemoveAssigned,
    } = VCardSettingsApp();

    if (contractorId !== null || supplierId !== null) navigate(routes.forbidden);
    else if (!DEV && !permission?.includes(permissionObj?.WEB_VCARD_SETTINGS_UPDATE)) navigate(routes.forbidden);

    return (
        <>
            <HeadTittle name={'vCardSettings'} link={routes.employee.list}>
                <ButtonAction
                    id='btn_vcs_update'
                    name={'update'}
                    className={'btn-icon-edit'}
                    Icon={EditIcon}
                    onClick={() => {
                        handleUpdateVCardSettings();
                    }}
                />
            </HeadTittle>
            <DivContainerBody>
                <div className='row m-0 p-0'>
                    <div className='col-12 col-md-3 m-0 p-0'>
                        <CustomCard classCard={'card-border-8px'} classContent={'p-0'}>
                            <div className='d-flex align-items-center m-3'>
                                <EyeIcon className='w-h-24px' />
                                <p className={' ibl-font-w-600 fs-16px font-color-general-950 ml-2'}>{t('preview')}</p>
                            </div>
                            <div className={'border-bottom-shades-300'} />
                            <div className='d-flex flex-column align-items-center'>
                                <CustomCard
                                    classCard={'card-border-8px border-full-shades-300-2px'}
                                    classContent={'p-0'}
                                    classes='mt-3 mb-2'
                                >
                                    <div className='p-3 d-flex justify-content-center'>
                                        <div className='position-relative d-inline-block'>
                                            <QRDefault
                                                style={QrDefaultStyle(colorVCard)}
                                                className='img-fluid maxw-260px'
                                            />

                                            {(photoPicker?.srcSelected || photoPicker?.previewImage   || IconCubeDefault) && (
                                                <img
                                                    src={photoPicker?.srcSelected || photoPicker?.previewImage || IconCubeDefault}
                                                    alt='Center preview'
                                                    className='position-absolute top-50 start-50 translate-middle rounded w-56px h-60px'
                                                />
                                            )}
                                        </div>
                                    </div>
                                </CustomCard>
                                <p className={' ibl-font-w-400 fs-12px font-color-shades-600 ml-2 mb-3'}>
                                    {t('qr_not_scannable')}
                                </p>
                            </div>

                            <InformationItem
                                titleKey='phone_number_work'
                                value='+52 442 555 0199'
                                icon={<PhoneOutlined className='w-21px  h-21px' />}
                                iconContainerClass='background-success-100'
                                align='center'
                            />
                            <InformationItem
                                titleKey='phone_number_personal'
                                value='+52 55 1234 5678'
                                icon={<PhoneOutlined className='w-21px  h-21px' />}
                                iconContainerClass='background-success-100'
                                align='center'
                            />
                            <InformationItem
                                titleKey='web'
                                value='www.johndoe.co'
                                icon={<IconWeb className='w-21px  h-21px' />}
                                iconContainerClass='background-success-100'
                                align='center'
                            />
                            <InformationItem
                                titleKey='street'
                                value='Av. Tecnológico 150, Int. 4B'
                                icon={<IconMarkerTable className='w-21px  h-21px' />}
                                iconContainerClass='background-success-100'
                                align='center'
                            />
                            <InformationItem
                                titleKey='postal_code'
                                value='76000'
                                icon={<EmailSubsectionChip className='w-21px  h-21px' />}
                                iconContainerClass='background-success-100'
                                align='center'
                            />
                            <InformationItem
                                titleKey='city'
                                value='Santiago de Querétaro'
                                icon={<IconMarketLocation className='w-21px  h-21px' />}
                                iconContainerClass='background-success-100'
                                align='center'
                            />
                            <InformationItem
                                titleKey='state'
                                value='Querétaro'
                                icon={<IconAreaTable className='w-21px  h-21px' />}
                                iconContainerClass='background-success-100'
                                align='center'
                            />
                            <InformationItem
                                titleKey='country'
                                value='México'
                                icon={<MapTabIcon className='w-21px  h-21px' />}
                                iconContainerClass='background-success-100'
                                align='center'
                            />
                        </CustomCard>
                    </div>
                    <div className='col-12 col-md-9 m-0 p-0 pl-md-3'>
                        <CustomCard classCard={'card-border-8px'} classContent={'p-0'}>
                            <div className='d-flex align-items-center m-3'>
                                <SettingsIcon className='icon-color-general-950 w-h-24px' />
                                <p className={' ibl-font-w-600 fs-16px font-color-general-950 ml-2'}>{t('settings')}</p>
                            </div>
                            <div className={'border-bottom-shades-300'} />
                            <div className='row m-0 p-0'>
                                <div className='col-12 col-md-5 m-0 p-2'>
                                    <CustomCard classCard={'card-border-8px'} classContent={'p-0'}>
                                        <div className='d-flex align-items-center m-3'>
                                            <SettingsIcon className='icon-color-general-950 w-h-24px' />
                                            <p className={' ibl-font-w-600 fs-16px font-color-general-950 ml-2'}>
                                                {t('employee_data')}
                                            </p>
                                        </div>
                                        <div className={'border-bottom-shades-300'} />
                                        <div className='maxh-500px overflow-y-auto pr-2 pl-2'>
                                            <CustomListContainer>
                                                <div
                                                    className={'headers-availables'}
                                                    onDrop={handleDropAvailable}
                                                    onDragOver={handleDragOver}
                                                >
                                                    {availableHeaders
                                                        .filter(
                                                            (header) =>
                                                                !Object.values(assignedItems).includes(header.title) &&
                                                                header.title !== null,
                                                        )
                                                        .map((header, index) => (
                                                            <div
                                                                key={index}
                                                                draggable
                                                                onDragStart={(e) => handleDragStart(header.title, e)}
                                                            >
                                                                <DraggableCard
                                                                    item={''}
                                                                    backgroundColor='background-shades-50'
                                                                    className='mb-2'
                                                                    classNameIconContainer='w-40px'
                                                                    body={
                                                                        <div className='py-12px pr-3'>
                                                                            {header.title}
                                                                        </div>
                                                                    }
                                                                />
                                                            </div>
                                                        ))}
                                                </div>
                                            </CustomListContainer>
                                        </div>
                                    </CustomCard>
                                </div>
                                <div className='col-12 col-md-7 m-0 p-2 pt-md-2 pe-md-2'>
                                    <CustomCard classCard={'card-border-8px'} classContent={'p-0'}>
                                        <div className='d-flex align-items-center m-3'>
                                            <SettingsIcon className='icon-color-general-950 w-h-24px' />
                                            <p className={' ibl-font-w-600 fs-16px font-color-general-950 ml-2'}>
                                                {t('vcard_structure')}
                                            </p>
                                        </div>
                                        <div className={'border-bottom-shades-300'} />
                                        <div className='maxh-500px overflow-y-auto pr-2 pl-2'>
                                            <CustomListContainer>
                                                {Object.keys(assignedItems).map((key, i) => (
                                                    <div
                                                        key={key}
                                                        className='container-item-assigned w-100 mt-2 ml-2 mr-2  border-full-shades-300'
                                                        onDrop={(e) => handleDropAssigned(e, key)}
                                                        onDragOver={handleDragOver}
                                                        id={`slt_vcs_item_${i}`}
                                                    >
                                                        <h1 className='fs-14px ibl-font-w-600 font-color-general-950 p-2'>
                                                            {t(key.replace(/_/g, ' '))}
                                                        </h1>
                                                        <div className='background-general-00 p-2 mt-2 w-100 border-top-shades-300'>
                                                            {assignedItems[key] ? (
                                                                <div
                                                                    className='d-flex
                                                            justify-content-center
                                                            align-items-center
                                                            m-1 h-50px w-100'
                                                                >
                                                                    <CustomCard
                                                                        classCard='card-border-8px'
                                                                        classContent='p-0 w-100'
                                                                        classes='h-50px w-100 d-flex justify-content-between align-items-center '
                                                                    >
                                                                        <div
                                                                            className='w-100 fs-12px ibl-font-w-500 font-color-general-950 pl-2 d-flex justify-content-between align-items-center pr-2'
                                                                            draggable
                                                                            onDragStart={(e) =>
                                                                                handleDragStart(assignedItems[key], e)
                                                                            }
                                                                            id={`slt_vcs_item_${i}`}
                                                                        >
                                                                            {assignedItems[key]}
                                                                            <CrossIconsOptions
                                                                                className='icon-color-shades-400 w-h-24px'
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleRemoveAssigned(key);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </CustomCard>
                                                                </div>
                                                            ) : (
                                                                <div
                                                                    className='header-item-assigned'
                                                                    onDrop={handleDropAvailable}
                                                                    onDragOver={handleDragOver}
                                                                >
                                                                    <p className='ibl-font-w-700 fs-14px font-color-accent-400 m-0'>
                                                                        {t('drag_a_field_here')}
                                                                    </p>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))}
                                            </CustomListContainer>
                                        </div>
                                    </CustomCard>
                                </div>
                            </div>
                            <div className='row m-0 p-0'>
                                <div className='col-12 col-md-5 m-0 p-2'>
                                    <CustomCard classCard='card-border-8px h-100' classContent='p-0'>
                                        <div className='d-flex align-items-center m-3'>
                                            <IconColorPalette className='icon-color-general-950 w-h-24px' />
                                            <p className='ibl-font-w-600 fs-16px font-color-general-950 ml-2'>
                                                {t('color')}
                                            </p>
                                        </div>

                                        <div className='border-bottom-shades-300' />

                                        <div className='mt-3 px-3 pb-3 minh-433px'>
                                            <ColorPicker
                                                id='clp_vcs_colorInTime'
                                                color={colorVCard}
                                                setColor={setColorVCard}
                                                preview={false}
                                            />
                                        </div>
                                    </CustomCard>
                                </div>

                                <div className='col-12 col-md-7 m-0 p-2'>
                                    <CustomCard classCard='card-border-8px' classContent='p-0'>
                                        <div className='d-flex align-items-center m-3'>
                                            <IconClip className='icon-color-general-950 w-h-24px' />
                                            <p className='ibl-font-w-600 fs-16px font-color-general-950 ml-2'>
                                                {t('image_logo')}
                                            </p>
                                        </div>

                                        <div className='border-bottom-shades-300' />

                                        <div className='mt-3 pb-3 minh-433px d-flex justify-content-center'>
                                            <CustomPhotoPicker
                                                id='fp_vcs_image_logo'
                                                photoPicker={photoPicker}
                                                setPhotoPicker={setPhotoPicker}
                                                actionModel={ACTION_MODEL.UPDATE}
                                                accept={{ ...FILE_TYPE.IMAGE }}
                                                classWith='w-400px'
                                            />
                                        </div>
                                    </CustomCard>
                                </div>
                            </div>
                        </CustomCard>
                    </div>
                </div>
            </DivContainerBody>
        </>
    );
};

export default VCardSettings;
